export default __webpack_public_path__ + "static/time-axis-with-irregular-intervals-4b68f82e85cb739008fef3510da9473a.png";